import { memo, useEffect, useMemo, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { checkExpandedRowsContainRow } from "../../../../selectors/home"
import { OptionExpiryType } from "../../../../reducer/options.reducer"
import { RootState } from "../../../../store"
import { Typography } from "@mui/material"
import ThinArrowDownIcon from "../../../../assets/icons/ThinArrowDownIcon";
import ThinArrowRightIcon from "../../../../assets/icons/ThinArrowRightIcon";
import { matchPath } from "react-router-dom"
import ROUTES from "../../../../assets/routes"
import { OptionChainViewKey } from "../../../../assets/constants"

const getExpiryColumnClassName = (darkTheme: boolean): string => {
    const baseClasses = 'flex h-full items-center align-middle font-feature-num'
    const backgroundClass = darkTheme ? 'bg-row-open-dark' : 'bg-row-open'
    return `${baseClasses} ${backgroundClass}`
}

const RenderExpiryColumn = ({ RecKey, text, optionTypeOnly = false }: { RecKey: string, text: string, optionTypeOnly?: boolean }) => {
    const rowExpanded = useSelector(checkExpandedRowsContainRow(RecKey, matchPath(ROUTES.simulator, window.location.pathname) ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE))
    const data = useMemo(() => JSON.parse(text) as OptionExpiryType, [text])
    const darkTheme = useSelector((store: RootState) => store.commonStore.darkTheme)
    const [fullWidth, setFullWidth] = useState("100%");
    const rowRef = useRef<HTMLDivElement>(null);
    const expiryColumnClassName = getExpiryColumnClassName(darkTheme)
    
    if (rowExpanded || optionTypeOnly) {
        return (
            <div
                ref={rowRef}
                className={`h-full align-middle font-feature-num`}
                style={{
                    display: 'flex',
                    width: fullWidth ?? '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    minWidth: "100%",
                    position: 'relative'
                }}
            >
                {
                    optionTypeOnly ? <div></div> :
                        <div className="flex items-center expiry-date-sticky" style={{
                            position: 'sticky',
                            left: 0,
                            zIndex: 5,
                            paddingRight: '8px',
                            gap: '8px'
                        }}>
                            <ThinArrowDownIcon fontSize={"small"} />
                            <div className="text-left ml-1" style={{ width: '110px' }}>{data.expirationDate}</div>
                            <div>{data.weeklyExpiry ?
                                <Typography variant={'caption'} className="ml-3 p-1 rounded-sm"
                                    sx={{ backgroundColor: theme => theme.palette.divider }}>W</Typography> : null}</div>
                        </div>
                }
                <div className="calls-heading-sticky" style={{
                    position: 'sticky',
                    right: 0,
                    zIndex: 5,
                    paddingRight: '8px',
                }}>Calls</div>
            </div>
        )
    }
    return (
        <div ref={rowRef} className={expiryColumnClassName}
            style={{
                width: fullWidth ?? '100%',
                minWidth: '100%',
                display: 'flex',
                alignItems: 'center',
                position: 'relative'
            }}
        >
            <div style={{
                position: 'sticky',
                left: 0,
                zIndex: 20,
                display: 'flex',
                alignItems: 'center',
                paddingRight: '8px',
                minWidth: '110px',
                flexShrink: 0,
                gap: '8px'
            }}>
                <ThinArrowRightIcon fontSize="small" />
                <div className="text-left ml-1" style={{ whiteSpace: 'nowrap' ,width: '110px'}}>
                    {data.expirationDate}
                </div>

                {data.weeklyExpiry && (
                    <Typography
                        variant="caption"
                        className="ml-2 p-1 rounded-sm"
                        sx={{
                            backgroundColor: (theme) => theme.palette.divider,
                            fontSize: '0.7rem',
                            lineHeight:1
                        }}
                    >
                        W
                    </Typography>
                )}
            </div>
        </div>
    )
}

export default memo(RenderExpiryColumn)